import request from '@/utils/request'

let StaffApi = {

  /*商家会员列表*/
  list(data) {
    return request._post('/shop/plus.staff.Index/index', data);
},
/*添加商家会员*/
add(data) {
    return request._post('/shop/plus.staff.Index/add', data);
},
/*修改商家会员*/
edit(data) {
    return request._post('/shop/plus.staff.Index/edit', data);
},
/*删除商家会员*/
del(data) {
    return request._post('/shop/plus.staff.Index/del', data);
},
/*商家会员详情*/
detail(data) {
  return request._post('/shop/plus.staff.Index/detail', data);
},
saveSetting(data, errorback) {
  return request._post('/shop/plus.staff.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.staff.Setting/getSetting', data, errorback);
},

supply(data) {
  return request._post('/shop/plus.staff.Index/supply', data);
},
/*关联商家会员到商家*/
sadd(data) {
  return request._post('/shop/plus.staff.Index/sadd', data);
},
/*修改关联商家会员到商家*/
sedit(data) {
  return request._post('/shop/plus.staff.Index/sedit', data);
},
/*删除关联商家会员到商家*/
sdel(data) {
  return request._post('/shop/plus.staff.Index/sdel', data);
},
/*关联商家会员到商家详情*/
sdetail(data) {
  return request._post('/shop/plus.staff.Index/sdetail', data);
},

}
export default StaffApi;



// WEBPACK FOOTER //
// ./src/api/staff.js